var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaviconAvoprime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #146152;\n      }\n\n      .cls-2 {\n        fill: #b4cf66;\n      }\n\n      .cls-3 {\n        fill: none;\n      }\n\n      .cls-4 {\n        fill: #44803f;\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 4.41,
    y: 1.38,
    width: 22.51,
    height: 29.23
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.72,30.62s-.06,0-.08,0c-3.32-.02-6.3-1.35-8.4-3.73-2.16-2.46-3.15-5.81-2.73-9.19.36-2.86,2.05-6.64,4.52-10.13,2.51-3.52,5.18-5.82,7.15-6.15,1.23-.2,2.23.34,2.81,1.54,1.1,2.26,2.32,3.8,3.51,5.29,1.9,2.38,3.7,4.63,4.31,9.27.47,3.6-.48,6.95-2.67,9.43-2.09,2.36-5.08,3.66-8.42,3.66M16.67,2.39c-.11,0-.22,0-.34.03-1.68.28-4.17,2.48-6.49,5.74-2.35,3.3-4.01,7.01-4.34,9.67-.39,3.09.52,6.15,2.49,8.39,1.9,2.17,4.62,3.37,7.65,3.39.03,0,.05,0,.08,0,3.05,0,5.77-1.18,7.66-3.32,2-2.26,2.86-5.33,2.42-8.63-.57-4.37-2.21-6.41-4.1-8.77-1.22-1.53-2.49-3.11-3.63-5.48-.33-.68-.78-1.01-1.4-1.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.21,20.65c.67-1.05.89-2.29.62-3.51-.27-1.21-.99-2.25-2.04-2.92-1.05-.67-2.29-.89-3.51-.62-1.21.27-2.25.99-2.92,2.04-.41.65-.66,1.39-.72,2.15.21,0,.41,0,.62.02,2.15.18,4.06,1.69,5.83,4.62.87-.37,1.6-.98,2.11-1.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M25.01,17.58c-.84-6.51-4.27-7.46-6.84-12.82C15.89,0,7.1,11.18,6.29,17.74c-.03.27-.06.54-.07.81.64-.03,1.32-.19,2.02-.36.48-.11,1.36-.31,1.36-.31.04-.99.35-1.96.89-2.8.82-1.28,2.09-2.17,3.57-2.5,1.49-.33,3.01-.06,4.29.76,1.28.82,2.17,2.09,2.5,3.57.33,1.49.06,3.01-.76,4.29-.6.95-1.45,1.67-2.46,2.13.01.02.02.03.03.05.86,1.47,1.74,2.99,2.97,4.02,3.12-1.87,4.94-5.53,4.38-9.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M16.76,23.92c-.16-.27-.31-.54-.47-.8-1.61-2.71-3.28-4.11-5.11-4.26-.87-.07-1.76.14-2.7.36-.74.17-1.5.35-2.25.39.26,4.92,3.96,9.1,9.41,9.14,1.45,0,2.8-.28,4-.8-1.2-1.12-2.05-2.58-2.88-4.01"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaviconAvoprime);
export default __webpack_public_path__ + "static/media/favicon-avoprime.da543fe7a12f0219fe46cb79954f57ca.svg";
export { ForwardRef as ReactComponent };